document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll(".card-wrapper .product-button--primary");

  const isFullyVisible = (el) => {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  const animateRandomVisibleButton = () => {
    buttons.forEach(btn => btn.classList.remove("waggle-animation"));

    const visibleButtons = Array.from(buttons).filter(isFullyVisible);
    if (visibleButtons.length === 0) return;

    const randomIndex = Math.floor(Math.random() * visibleButtons.length);
    const randomButton = visibleButtons[randomIndex];

    randomButton.classList.add("waggle-animation");

    setTimeout(() => {
      randomButton.classList.remove("waggle-animation");
    }, 1500);
  };

  animateRandomVisibleButton();

  setInterval(animateRandomVisibleButton, 3000);
});
